export default __webpack_public_path__ + "static/media/Black-Lava-Beaded-Diffuser-Stretch-Bracelet.2114cf8a.jpg";